import { createFileRoute } from '@tanstack/react-router'
import { InteractionsTab } from '~/components/routes/visioReviews/InteractionsTab'
import { VisioReviewsLayout } from '~/components/routes/visioReviews/VisioReviewsLayout'
import { visioReviewsSearchSchema } from '~/components/routes/visioReviews/search'
import { VISIO_REVIEWS_TAB_PERMISSIONS } from '~/components/routes/visioReviews/tabs'
import { withRoutePermissions } from '~/utils/rbac'

export const Route = createFileRoute('/_authenticated/visio-reviews/veille')({
  staticData: {
    permission: VISIO_REVIEWS_TAB_PERMISSIONS.veille,
  },
  validateSearch: visioReviewsSearchSchema,
  component: VisioReviewsVeillePage,
})
withRoutePermissions(Route)

function VisioReviewsVeillePage() {
  const search = Route.useSearch()
  const navigate = Route.useNavigate()

  return (
    <VisioReviewsLayout
      activeTab="veille"
      search={search}
      onSearchChange={(next) => navigate({ search: next })}
    >
      {/* Plage figée à la veille : cet onglet ignore la période de l'URL. */}
      <InteractionsTab />
    </VisioReviewsLayout>
  )
}
